module.exports = __webpack_public_path__ + "img/emoji/kappa.2d9b95bec793d9343b22349ceec89a16.png";